import type { RangeItem } from '../types/range-legend.js';
import { getFilteredItems } from './get-filtered-items.js';
import { getInternalRangeItems } from './get-internal-range-items.js';

export const mapToInternalRangeItems = (items: RangeItem[]) => {
  const filteredItems = getFilteredItems(items);

  return getInternalRangeItems(filteredItems);
};
